import React from 'react';
import { twMerge } from 'tailwind-merge';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { TIERS } from '@utils/tiers';

interface Props
  extends Omit<React.ComponentProps<typeof NextFutureImage>, 'src' | 'alt' | 'width' | 'height'> {
  type: TIERS | 'goldenEgg';
  size?: number;
}

export default function BadgeImage({ type, size = 18, className, ...props }: Props) {
  const imageProps = (() => {
    switch (type) {
      case 'goldenEgg':
        return {
          alt: 'goldenEggBadge',
          src: '/images/golden-egg-badge.png',
        };
      case TIERS.LIMITED:
        return {
          alt: 'starBadge',
          src: '/images/star-badge.png',
        };
      default:
        return {
          alt: 'checkBadge',
          src: '/images/check-badge.png',
        };
    }
  })();

  return (
    <NextFutureImage
      {...props}
      className={twMerge(`h-[${size}px] w-[${size}px]`, className)}
      width={size}
      height={size}
      {...imageProps}
    />
  );
}
